module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-48.f6281729.jpg";